import Phaser from 'phaser';

export const LOGICAL_WIDTH = 480;
export const LOGICAL_HEIGHT = 270;
export const RENDER_SCALE = 2;

export function configureLogicalCamera(scene: Phaser.Scene): void {
  scene.cameras.main
    .setZoom(RENDER_SCALE)
    .centerOn(LOGICAL_WIDTH / 2, LOGICAL_HEIGHT / 2);
}
